const COOKIE_NAME = 'aimcenter_announcement_dismissed';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}; path=/`;
  return value;
}

function showModal(modal) {
  modal.classList.remove('hidden');
  // Trigger reflow for transition
  modal.offsetHeight;
  modal.classList.add('opacity-100');
  modal.classList.remove('opacity-0');
}

function hideModal(modal, hash) {
  modal.classList.add('opacity-0');
  modal.classList.remove('opacity-100');

  modal.addEventListener('transitionend', function handler() {
    modal.classList.add('hidden');
    setCookie(COOKIE_NAME, hash, 30);
    modal.removeEventListener('transitionend', handler);
  }, { once: true });
}

function initAnnouncement() {
  const modal = document.getElementById('announcement-modal');
  if (!modal) return;

  const hash = modal.dataset.hash;
  if (!hash) return;

  const closeBtn = document.getElementById('announcement-close');
  if (!closeBtn) return;

  closeBtn.addEventListener('click', () => hideModal(modal, hash));

  const dismissedHash = getCookie(COOKIE_NAME);

  // Close on overlay click (outside content box)
  const content = document.getElementById('announcement-content');
  modal.addEventListener('click', (e) => {
    if (content && !content.contains(e.target)) {
      hideModal(modal, hash);
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
      hideModal(modal, hash);
    }
  });

  // Show modal if hash is different or no cookie exists
  if (dismissedHash !== hash) {
    showModal(modal);
  }
}

initAnnouncement();
